import { createPortal } from 'react-dom';
import styled from "styled-components/macro";
import { usePopperTooltip } from 'react-popper-tooltip';

type ChildrenCallbackProps = {
    triggerRef: React.Dispatch<React.SetStateAction<HTMLElement | null>>;
}

type TooltipProps = {
    children({triggerRef}: ChildrenCallbackProps): React.ReactNode;
    content: React.ReactNode;
    onContentClick?(): void;
}

const StyledTooltip = styled.div<{ clickable: boolean }>`
    padding: 6px 10px 5px;
    background: rgba(255, 255, 255, .9);
    color: ${props => props.theme.colors.gray2};
    font-weight: 700;
    font-size: 14px;
    border-radius: 3px;
    z-index: 9999;
    pointer-events: auto;
    cursor: ${props => props.clickable ? 'pointer' : 'default'};
`

const Tooltip = ({
    children,
    content,
    onContentClick
}: TooltipProps) => {
    const {
        getTooltipProps,
        setTooltipRef,
        setTriggerRef,
        visible,
    } = usePopperTooltip({
        placement: 'top',
        offset: [0, 5],
        interactive: true,
    });

    const ref = children({triggerRef: setTriggerRef});

    return (
        <>
            {ref}
            {visible &&
                createPortal(
                    <StyledTooltip
                        ref={setTooltipRef}
                        clickable={!!onContentClick}
                        {...getTooltipProps({
                            onClick: onContentClick,
                        })}
                    >
                        {content}
                    </StyledTooltip>,
                    document.body
                )
            }
        </>
    );
}

export default Tooltip;
